import { render, staticRenderFns } from "./AppSubTitle.vue?vue&type=template&id=2a33499c&scoped=true"
import script from "./AppSubTitle.vue?vue&type=script&lang=js"
export * from "./AppSubTitle.vue?vue&type=script&lang=js"
import style0 from "./AppSubTitle.vue?vue&type=style&index=0&id=2a33499c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33499c",
  null
  
)

export default component.exports